(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["qb-avant-apres"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('[data-qb-ba-section]');
  sections.forEach(function (section) {
    section.querySelectorAll('[data-qb-ba]').forEach(function (slider) {
      var range = slider.querySelector('[data-qb-ba-range]');
      if (!range) return;
      function update() {
        slider.style.setProperty('--pos', range.value);
      }
      range.addEventListener('input', update);
      range.addEventListener('change', update);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qb-produits-favoris"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('[data-qb-favoris]');
  sections.forEach(function (section) {
    var filters = section.querySelectorAll('[data-qb-filter]');
    var panels = section.querySelectorAll('[data-qb-panel]');
    var viewAll = section.querySelector('[data-qb-viewall]');

    filters.forEach(function (filter) {
      filter.addEventListener('click', function () {
        var id = filter.getAttribute('data-qb-filter');
        var url = filter.getAttribute('data-qb-view-all');

        filters.forEach(function (f) {
          var active = f === filter;
          f.classList.toggle('is-active', active);
          f.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        panels.forEach(function (p) {
          var active = p.getAttribute('data-qb-panel') === id;
          p.classList.toggle('is-active', active);
          if (active) {
            p.removeAttribute('hidden');
          } else {
            p.setAttribute('hidden', '');
          }
        });

        if (viewAll && url) {
          viewAll.setAttribute('href', url);
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
